import { Stack, Typography } from "@mui/material"
import { ClaimDTO } from "../../../../client/motalvip-apis/generated"
import { ClaimStatusColorMapping, ClaimStatusDescriptionMapping, ClaimStatusNameMapping } from "../../constants"
import dayjs from "dayjs"

interface Props {
    status: ClaimDTO.status
    createdAt: string
}

export const HistoryItem = ({ status, createdAt }: Props) => {
    return (
        <Stack alignItems="start" sx={{ border: '1px solid #A1A7AA', borderRadius: '4px', padding: '20px', width: { xs: '250px', md: '470px' } }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', borderBottom: '1px solid #C0C4C6', paddingBottom: '4px', marginBottom: '12px' }}>
                <Typography fontSize="20px" fontWeight={500} color={ClaimStatusColorMapping[status]}>
                    {ClaimStatusNameMapping[status]}
                </Typography>
                <Typography fontSize="16px" fontWeight={400} color="#334046">
                    {dayjs(createdAt!).format('DD/MM/YYYY HH:mm น.')}
                </Typography>
            </Stack>
            <Typography fontSize="16px" fontWeight={400} color="#6F6F6F">
                {ClaimStatusDescriptionMapping[status]}
            </Typography>
        </Stack>
    )
}